import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

const SignaturePad = ({ onChange, testid = "signature-canvas" }) => {
    const canvasRef = useRef(null);
    const drawing = useRef(false);
    const [hasInk, setHasInk] = useState(false);

    useEffect(() => {
        const canvas = canvasRef.current;
        canvas.width = 900;
        canvas.height = 280;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.lineWidth = 4;
        ctx.lineCap = "round";
        ctx.lineJoin = "round";
        ctx.strokeStyle = "#0A0F24";
    }, []);

    const pos = (e) => {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        return {
            x: (e.clientX - rect.left) * (canvas.width / rect.width),
            y: (e.clientY - rect.top) * (canvas.height / rect.height),
        };
    };

    const start = (e) => {
        drawing.current = true;
        const ctx = canvasRef.current.getContext("2d");
        const p = pos(e);
        ctx.beginPath();
        ctx.moveTo(p.x, p.y);
        e.target.setPointerCapture(e.pointerId);
    };

    const move = (e) => {
        if (!drawing.current) return;
        const ctx = canvasRef.current.getContext("2d");
        const p = pos(e);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
    };

    const end = () => {
        if (!drawing.current) return;
        drawing.current = false;
        setHasInk(true);
        onChange(canvasRef.current.toDataURL("image/png"));
    };

    const clear = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        setHasInk(false);
        onChange(null);
    };

    return (
        <div>
            <canvas
                ref={canvasRef}
                data-testid={testid}
                className="h-44 w-full touch-none rounded-2xl border-2 border-dashed border-brand/40 bg-white"
                onPointerDown={start}
                onPointerMove={move}
                onPointerUp={end}
                onPointerCancel={end}
            />
            <div className="mt-2 flex items-center justify-between">
                <p className="text-xs text-slate-500">{hasInk ? "Signature enregistrée" : "Le client signe ici, au doigt"}</p>
                <button
                    type="button"
                    data-testid="signature-clear"
                    onClick={clear}
                    className="inline-flex items-center gap-1.5 rounded-full border border-black/15 px-4 py-2 text-sm font-semibold text-slate-600 transition-colors hover:border-brand hover:text-brand"
                >
                    <Eraser className="h-4 w-4" />
                    Effacer
                </button>
            </div>
        </div>
    );
};

export default SignaturePad;
